import { Dayjs } from 'dayjs';
import { TUser } from '../states/userSlice';

const lib = {
  getLocalStorage(key: string) {
    const localStoreItem = localStorage.getItem(key) as string;

    if (localStoreItem) {
      return JSON.parse(localStoreItem);
    } else {
      return null;
    }
  },

  setLocalStorage(key: string, value: TUser | string) {
    const parsedValue = JSON.stringify(value);

    localStorage.setItem(key, parsedValue);
  },

  removeLocalStorageItem(key: string) {
    localStorage.removeItem(key);
  },
};

export default lib;

export function isObjectEmpty(obj: object) {
  return Object?.keys(obj)?.length === 0;
}

export function formatQueryParams(params: any) {
  const searchParams = new URLSearchParams();

  Object.keys(params).forEach((key) => {
    if (params[key] !== undefined && params[key] !== null && params[key]) {
      searchParams.append(key, params[key]);
    }
  });

  return searchParams.toString();
}

export function getFirst100WordsFromHTML(html: any, size: number = 100) {
  const plainText = html?.replace(/<[^>]*>/g, '');

  if (plainText?.length > size) {
    return plainText.slice(0, size) + '....';
  }

  return plainText;
}
